import React, { Component } from "react";
import { connect } from "react-redux";
import * as userActions from "../../_actions/userActions";
import Wrapper from "../../_hoc/Wrapper";
import Section from "../UI/Section";
import SimpleList from "../UI/SimpleList";
import Input from "../UI/Input";
import getMySearchVisibilitySetting from "../../_selectors/userSelectors/getMySearchVisibilitySetting";
import moment from "moment";
import Modal from "react-responsive-modal";
import { confirmAlert } from "react-confirm-alert";
import getMyBirthDate from "../../_selectors/userSelectors/getMyBirthDate";
import getMyEmailInfo from "../../_selectors/userSelectors/getMyEmailInfo";
import getDisplayName from "../../_selectors/userSelectors/getDisplayName";
import getMyMobileNumber from "../../_selectors/userSelectors/getMyMobileNumber";
import getMyProfileCreatedOn from "../../_selectors/userSelectors/getMyProfileCreatedOn";
import { getRelativeTime } from "../../_utils";
import ResetPassword from "./ResetPassword";
/*eslint-disable */
const simpleListItem = [
  {
    text: ({ search }) =>
      search ? (
        <Wrapper>
          <i class="fa fa-eye-slash" /> Hide in Search Results
        </Wrapper>
      ) : (
        <Wrapper>
          <i class="fa fa-eye" /> Show in Search Results
        </Wrapper>
      ),
    onClick: component => {
      component.toggleSearchSetting();
    }
  },
  {
    text: () => (
      <Wrapper>
        <i class="fa fa-key" /> Reset Password
      </Wrapper>
    ),
    onClick: component => {
      component.toggleModal();
    }
  },

  {
    text: () => (
      <Wrapper>
        <i class="fa fa-trash-o" /> Delete Account
      </Wrapper>
    ),
    onClick: component => {
      component.disableAccount();
    }
  }
];

class Settings extends Component {
  state = { isModalOpen: false };
  componentDidMount() {
    const { updateHeader, updateBreadcrumb } = this.props;
    updateHeader({
      title: "Settings",
      description: "Place to find your special one"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Settings", link: "/profile" }
    ]);
  }
  toggleSearchSetting = () => {
    const {
      search,
      updateSearchSetting,
      updateAge,
      birthDate,
      history
    } = this.props;
    let updatedSearch = !search;

    if (updatedSearch) {
      if (birthDate) {
        try {
          updateAge(moment().diff(birthDate.toDate(), "years"));
          updateSearchSetting({ data: { search: updatedSearch } });
        } catch (error) {
          updateAge(0);
          updateSearchSetting({ data: { search: updatedSearch } });
        }
      } else {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="custom-ui">
                <h1>Update Profile</h1>
                <p>
                  Please update your profile so that you can feature in the
                  search results.
                </p>
                <button onClick={onClose}>Later</button>
                <button
                  onClick={() => {
                    onClose();
                    history.push("/profile");
                  }}
                >
                  Update!
                </button>
              </div>
            );
          }
        });
      }
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Are you sure?</h1>
              <p>You will not feature in any of the search results.</p>
              <button onClick={onClose}>No</button>
              <button
                onClick={() => {
                  onClose();
                  updateAge(0);
                  updateSearchSetting({ data: { search: updatedSearch } });
                }}
              >
                Yes
              </button>
            </div>
          );
        }
      });
    }
  };
  disableAccount = () => {
    const { deleteUser } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You will no longer be able to use AMST features.</p>
            <button onClick={onClose}>No</button>
            <button
              onClick={() => {
                onClose();
                deleteUser();
              }}
            >
              Yes, Delete!
            </button>
          </div>
        );
      }
    });
  };
  toggleModal = () => {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen
    }));
  };
  render() {
    const { isModalOpen } = this.state;
    const { email, mobile, name, createdOn } = this.props;
    return (
      <Wrapper>
        <Section>
          <div className="row row-wider">
            <div className="col-md-3">
              <SimpleList items={simpleListItem} component={this} hover />
            </div>
            <div className="col-md-9">
              <div className="form-group-one-unit">
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      value={email}
                      disabled
                      label={<Wrapper>Email</Wrapper>}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      value={name}
                      disabled
                      label={<Wrapper>Full Name</Wrapper>}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      value={mobile}
                      disabled
                      label={<Wrapper>Mobile</Wrapper>}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      value={createdOn ? getRelativeTime(createdOn) : "-"}
                      disabled
                      label={<Wrapper>Profile Created</Wrapper>}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>
        <Modal
          open={isModalOpen}
          onClose={this.toggleModal}
          center
          classNames={{ overlay: "amst-overlay", modal: "amst-modal" }}
        >
          <ResetPassword onClose={this.toggleModal} />
        </Modal>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  search: getMySearchVisibilitySetting(state),
  birthDate: getMyBirthDate(state),
  email: getMyEmailInfo(state),
  name: getDisplayName(state),
  mobile: getMyMobileNumber(state),
  createdOn: getMyProfileCreatedOn(state)
});

const mapDispatchToProps = dispatch => ({
  updateSearchSetting: payload =>
    dispatch(userActions.updatePrivacySetting(payload)),
  updateAge: age => dispatch(userActions.updateUserProfile({ data: { age } })),
  deleteUser: () => dispatch(userActions.deleteUser())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);



// WEBPACK FOOTER //
// ./src/_components/Settings/index.js